export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  featured: "home-featured",
  trending: "home-trending",
  newReleases: "home-new-releases",
  editorsChoice: "home-editors-choice",
  categories: "home-categories",
  topFree: "home-top-free",
  topPaid: "home-top-paid",
  openSource: "home-open-source",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  searchInput: "nav-search-input",
  searchBtn: "nav-search-btn",
  browseLink: "nav-browse-link",
  categoriesLink: "nav-categories-link",
  developersLink: "nav-developers-link",
  feedLink: "nav-feed-link",
  getAppBtn: "nav-get-app-btn",
  loginBtn: "nav-login-btn",
  registerBtn: "nav-register-btn",
  coinsChip: "nav-coins-chip",
  profileMenu: "nav-profile-menu",
  logoutBtn: "nav-logout-btn",
};

export const APP_CARD = "app-card";
export const CATEGORY_CARD = "category-card";
export const APP_DETAIL = {
  root: "app-detail",
  downloadBtn: "app-detail-download-btn",
  qrToggle: "app-detail-qr-toggle",
  screenshots: "app-detail-screenshots",
  reviews: "app-detail-reviews",
  similar: "app-detail-similar",
  tipBtn: "app-detail-tip-btn",
  launchPwaBtn: "app-detail-launch-pwa-btn",
};
export const BROWSE = {
  root: "browse-root",
  filterCategory: "browse-filter-category",
  filterSort: "browse-filter-sort",
  filterPrice: "browse-filter-price",
  results: "browse-results",
};

export const AUTH = {
  loginRoot: "auth-login",
  registerRoot: "auth-register",
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submit: "auth-submit-btn",
  error: "auth-error",
  toggle: "auth-toggle",
  memberPath: "auth-member-path",
  developerPath: "auth-developer-path",
  planChoice: "auth-plan-choice",
};

export const DEV = {
  publishRoot: "dev-publish",
  tabUrl: "dev-tab-url",
  tabZip: "dev-tab-zip",
  tabGithub: "dev-tab-github",
  urlInput: "dev-url-input",
  urlPreviewBtn: "dev-url-preview-btn",
  urlPublishBtn: "dev-url-publish-btn",
  githubInput: "dev-github-input",
  githubPreviewBtn: "dev-github-preview-btn",
  githubPublishBtn: "dev-github-publish-btn",
  zipInput: "dev-zip-input",
  zipPublishBtn: "dev-zip-publish-btn",
  category: "dev-category",
  tags: "dev-tags",
  dashboardRoot: "dev-dashboard",
  appRow: "dev-app-row",
};

export const COMMENTS = {
  root: "comments-root",
  input: "comments-input",
  submit: "comments-submit",
  item: "comment-item",
  like: "comment-like",
  reply: "comment-reply",
  tip: "comment-tip",
};

export const FOLLOW = {
  btn: "follow-btn",
};

export const FEED_TABS = {
  forYou: "feed-tab-for-you",
  discover: "feed-tab-discover",
};

export const NOTIF = {
  bell: "notif-bell",
  dropdown: "notif-dropdown",
  item: "notif-item",
  readAll: "notif-read-all",
  empty: "notif-empty",
};

export const ANALYTICS = {
  root: "analytics-root",
  card: "analytics-card",
  totals: "analytics-totals",
  chart: "analytics-chart",
};

export const SHARE = {
  cardBtn: "share-card-btn",
  modal: "share-card-modal",
  download: "share-card-download",
  copy: "share-card-copy",
};

export const ADMIN = {
  root: "admin-root",
  tabOverview: "admin-tab-overview",
  tabApps: "admin-tab-apps",
  tabComments: "admin-tab-comments",
  tabCashouts: "admin-tab-cashouts",
  tabUsers: "admin-tab-users",
  tabTv: "admin-tab-tv",
  appRow: "admin-app-row",
  approveBtn: "admin-approve",
  suspendBtn: "admin-suspend",
  featureBtn: "admin-feature",
  editorsBtn: "admin-editors-choice",
  commentRow: "admin-comment-row",
  cashoutApprove: "admin-cashout-approve",
  cashoutReject: "admin-cashout-reject",
};

export const ADS = {
  root: "ads-root",
  watchBtn: "ads-watch-btn",
  playing: "ads-playing",
  balance: "ads-balance",
};

export const CASHOUT = {
  root: "cashout-root",
  amountInput: "cashout-amount",
  methodSelect: "cashout-method",
  handleInput: "cashout-handle",
  submit: "cashout-submit",
  history: "cashout-history",
};

export const FEATURED = {
  home: "home-featured-slots",
  boostBtn: "featured-boost-btn",
};

export const FEED = {
  root: "feed-root",
  card: "feed-card",
  likeBtn: "feed-like-btn",
  saveBtn: "feed-save-btn",
  tipBtn: "feed-tip-btn",
  openBtn: "feed-open-btn",
  shareBtn: "feed-share-btn",
  detailsBtn: "feed-details-btn",
};

export const COINS = {
  root: "coins-root",
  buyBtn: "coins-buy-btn",
  balance: "coins-balance",
};

export const TIP = {
  modal: "tip-modal",
  amountInput: "tip-amount-input",
  quick: "tip-quick",
  submit: "tip-submit-btn",
  close: "tip-close",
};

export const PROFILE = {
  root: "profile-root",
  library: "profile-library",
  tips: "profile-tips",
  subscribeBtn: "profile-subscribe-btn",
  streakCard: "profile-streak-card",
  gallery: "profile-gallery",
  loops: "profile-loops",
};

export const LOOP_WALL = {
  root: "loop-wall-root",
  card: "loop-wall-card",
  playBtn: "loop-wall-play",
  tipBtn: "loop-wall-tip",
};

export const GALLERY = {
  root: "gallery-root",
  card: "gallery-card",
  like: "gallery-like",
};

export const EMBED = {
  timerStart: "embed-timer-start",
  timerReset: "embed-timer-reset",
  diceRoll: "embed-dice-roll",
  tttReset: "embed-ttt-reset",
  drawSave: "embed-draw-save",
};
